import {
  Component,
  effect,
  inject,
  OnInit,
  TemplateRef,
  viewChild
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
  CheckForUpdateService,
  DeviceDetectionService
} from '@shared/services';
import { getPreferredLanguage, initLanguage } from '@shared/utils';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'moxi-root',
  imports: [RouterOutlet, TranslatePipe, NzButtonModule],
  template: `
    <router-outlet></router-outlet>

    <ng-template #reloadBtnTpl>
      <button nz-button nzType="primary" nzSize="small" (click)="onReloadApp()">
        {{ 'notifications.updateService.reloadBtn' | translate }}
      </button>
    </ng-template>
  `
})
export class AppComponent implements OnInit {
  private readonly checkForUpdateService = inject(CheckForUpdateService);
  private readonly deviceDetectionService = inject(DeviceDetectionService);

  refreshBtn = viewChild<TemplateRef<never>>('reloadBtnTpl');

  registerBtnEffect = effect(
    () => (this.checkForUpdateService.updateButton = this.refreshBtn())
  );

  ngOnInit(): void {
    initLanguage(getPreferredLanguage());
    this.deviceDetectionService.detectMobileDevice();
  }

  onReloadApp(): void {
    this.checkForUpdateService.reloadApp();
  }
}
